import { render } from "./PhotosListComponent.vue?vue&type=template&id=be95ba36&scoped=true&ts=true"
import script from "./PhotosListComponent.vue?vue&type=script&lang=ts"
export * from "./PhotosListComponent.vue?vue&type=script&lang=ts"

import "./PhotosListComponent.vue?vue&type=style&index=0&id=be95ba36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be95ba36"]])

export default __exports__